import { lazy } from 'react';

import { withSuspense } from '@/shared/lib/hocs/with-suspense.hoc';
import { PageLoader } from '@/widgets/page';

export const FaqPage = withSuspense(
	lazy(async () => await import('./faq-page.component')),
	PageLoader,
);
